import { render, staticRenderFns } from "./MainLanding.vue?vue&type=template&id=ed6d1a58&scoped=true&"
import script from "./MainLanding.vue?vue&type=script&lang=js&"
export * from "./MainLanding.vue?vue&type=script&lang=js&"
import style0 from "./MainLanding.vue?vue&type=style&index=0&id=ed6d1a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6d1a58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed6d1a58')) {
      api.createRecord('ed6d1a58', component.options)
    } else {
      api.reload('ed6d1a58', component.options)
    }
    module.hot.accept("./MainLanding.vue?vue&type=template&id=ed6d1a58&scoped=true&", function () {
      api.rerender('ed6d1a58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MainLanding.vue"
export default component.exports